import React, { memo, useEffect } from 'react';
import { isEmpty } from 'lodash';
import ChargersList from '../../../ChargersList/components/ChargersList';
import { dashboardTableId } from '../../component';

const DashboardChargersList = memo(
  ({ getColumnsConfig, user, getChargers, columnsConfig, openChangerModal, exportToCSV, config, advancedSearchEnabled, filterQuery }) => {
    useEffect(() => {
      getColumnsConfig({ config, user });
    }, []);

    return (
      <ChargersList
        isFilterApplied={filterQuery && !isEmpty(filterQuery.rules)}
        user={user}
        id={dashboardTableId}
        getData={getChargers}
        columnsConfig={columnsConfig}
        filterable={false}
        openChangerModal={openChangerModal}
        exportToCSV={exportToCSV}
        config={config}
        advancedSearchEnabled={advancedSearchEnabled}
        source="dashboard"
      />
    );
  },
  (prevProps, nextProps) =>
    prevProps.columnsConfig === nextProps.columnsConfig &&
    prevProps.data === nextProps.data &&
    prevProps.config === nextProps.config &&
    prevProps.filterQuery === nextProps.filterQuery &&
    prevProps.id === nextProps.id &&
    prevProps.advancedSearchEnabled === nextProps.advancedSearchEnabled &&
    prevProps.isFilterApplied === nextProps.isFilterApplied,
);

export default DashboardChargersList;
